import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XImage, XText } from "IZOX/_X";
import PAContainer from "../shared/PAContainer/PAContainer";
import { PageFlipper, QForm } from "IZOX/BLOCKS/Libs";
import { QFDate, QFDropdown, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import QUICKUI from "shared/QUICKUI";
import _ from "lodash";
import NewMaid from "./_gears/NewMaid";
import ViewMaid from "./_gears/ViewMaid";
import VarList from "shared/VarList";

/**
 * @augments {Component<Props, State>}
 */
class PAMaidManageW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      selected: [],
      page: 0,
      pageSize: 6,
      search: false,
      searchForm: {}
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetMaids();
      this.GetNationalityList();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAMaidManageW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetNationalityList = async () => {
    let docs = await VarList.GetList("Nationality");
    this.setState({
      nationalities: docs
    });
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    });
  }

  _Reload = () => {
    let {search} = this.state;
    if(search){
      this._toSearch();
    }else{
      this.GetMaids();
    }
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  onFormChange = (formValue) => {
    this.setState({
      searchForm: formValue
    });
  }

  GetMaids = async () => {
    let res = await ReqX.SendBE("/Web/Agent/GetMaids");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        docs: payload
      });
    }
  }

  _toClearSearch = () => {
    this.setState({
      searchForm: {},
      search: false
    }, () => {
      this.MountQForm?.Clear();
      this._Reload();
    });
  }

  _toSearch = async () => {
    let {searchForm} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/SearchMaids", {
      searchForm
    });
    let {Success, payload} = res;
    if(Success){
      this.setState({
        search: true,
        docs: payload
      });
    }
  }

  _toNewMaid = () => {
    GFunc.Backdrop(() => {
      return (
        <NewMaid Refresh={this.GetMaids}/>
      );
    }, {}, false);
  }

  _toPopupDetails = async (_id) => {
    GFunc.Backdrop(() => {
      return (
        <ViewMaid Refresh={this.GetMaids} docID={_id}/>
      );
    }, {}, false);
  }

  renderTextField(name, label, readOnly = false){
    let {userDoc} = this.state;
    let value = Accessor.Get(userDoc, name);
    return (
      <VStack fullWidth>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={12} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <QFText name={name} placeholder={LocaleX.Parse({
          EN: "Search ",
          TC: "搜尋 "
        }) + LocaleX.Parse(label).toLowerCase()} disabled={readOnly}
          defaultValue={value}
          p={12}
          focus_bColor={ColorX.CSS("Axit")}
          bColor={ColorX.CSS("Gray5")}/>
      </VStack>
    );
  }

  renderSearchForm(){
    let {search, searchForm, nationalities} = this.state;
    return (
      <QForm fullWidth p={16} bgColor={ColorX.CSS("pureWhite")}
        spacing={24} value={searchForm} onMounted={this.onMountQForm}
        onChange={this.onFormChange}>
        <HStack spacing={24}>
          {this.renderTextField("helperName", 
            {
              EN: "Name",
              TC: "姓名"
            })}
        </HStack>
        <HStack spacing={24}>
          {this.renderTextField("policyNo", 
            {
              EN: "Policy number / Insurance certificate No.",
              TC: "保單號碼 / 保險憑證號碼"
            })}
          {this.renderTextField("helperPassport", 
          {
            EN: "Helper's passport number / ID",
            TC: "家務助理的護照號碼 / 身分證號碼"
          })}
        </HStack>
        <HStack spacing={24} mB={24}>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={4}>
              <XText fontSize={12} color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Nationality",
                  TC: "國籍"
                })}
              </XText>
            </HStack>
            <QFDropdown name={"nationality"}
              options={nationalities}
              placeholder={LocaleX.Parse({
                EN: "Select Nationality",
                TC: "選擇國籍"
              })}
              valAccessor="_id"
              capAccessor="name"
              p={12}
              bW={1}
              height={44}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}
              allowSearch/>
          </VStack>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={4}>
              <XText fontSize={12} color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Date of birth",
                  TC: "出生日期"
                })}
              </XText>
            </HStack>
            <QFDate name={"dateOfBirth"}
              p={12}
              bW={1}
              height={44}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}
              placeholder={LocaleX.Parse({
                EN: "Date of birth",
                  TC: "出生日期"
              })}/>
          </VStack>
        </HStack>
        <HStack>
          <XButton onPress={this._toClearSearch} fullWidth
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Reset",
                  TC: "重置"
                })}
              </XText>
            </HStack>
          </XButton>
          <XButton onPress={this._toSearch} padding={0} pV={5} fullWidth
            color={ColorX.CSS(search ? "pureWhite" : "Axit")} 
            bgColor={ColorX.CSS(search ? "Axit" : "pureWhite")} 
            style={{borderColor: ColorX.CSS("Axit")}}
            bW={1} round={50}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Search",
                  TC: "搜尋"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  renderHeader(){
    return (
      <HStack mB={24}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={16}>
          {LocaleX.Parse({
            EN: "Domestic Helper Management",
            TC: "家務助理管理"
          })}
        </XText>
        <Spacer/>
        <XButton onPress={this._toNewMaid} pH={30} round={50}
            bgColor={ColorX.CSS("Axit")}
            color={ColorX.CSS("pureWhite")}
            padding={6}>
          <HStack>
            <XText bold fontSize={14}>
              {LocaleX.Parse({
                EN: "Add new helper",
                TC: "新增助理"
              })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderMaidHeader(){
    return (
      <HStack spacing={20}>
        <XText bold>
          {LocaleX.Parse({
            EN: "List helpers",
            TC: "助理名單"
          })}
        </XText>
        <Spacer/>
      </HStack>
    );
  }

  renderMaidDoc(doc, idx){
    let {nationalities} = this.state;
    let {_id, fullName, nationality, dateOfBirth} = doc ?? {};

    return (
      <VStack bgColor={ColorX.CSS("pureWhite")} width={255} height={184}
        p={16} spacing={10} key={idx} m={8} shadow round={3}>
        <HStack HAlign="[">
          <XText color={ColorX.CSS("Leaf")} fontSize={14} bold>
            {LocaleX.Parse(fullName)}
          </XText>
        </HStack>
        <HStack>
          <HStack spacing={5} HAlign="[" fitWidthToContent>
            <XImage source={"/Images/Icons/cm_nation.png"} width={30}/>
            <XText fontSize={12} color={ColorX.CSS("Gray3")} width={80}>
              {LocaleX.Parse({
                EN: "Nationality",
                TC: "國藉"
              })}
            </XText>
          </HStack>
          <HStack spacing={5} HAlign="]">
            <XText fontSize={14}>
              {LocaleX.Parse(VarList.GetOption(nationalities, nationality)?.name)}
            </XText>
          </HStack>
        </HStack>
        <HStack>
          <HStack spacing={5} HAlign="[" fitWidthToContent>
            <XImage source={"/Images/Icons/cm_dob.png"} width={20}/>
            <XText fontSize={12} color={ColorX.CSS("Gray3")} width={80}>
              {LocaleX.Parse({
                EN: "D.O.B.",
                TC: "出生日期"
              })}
            </XText>
          </HStack>
          <HStack HAlign="]">
            <XText fontSize={14}>
              {dateOfBirth ? ZTime.Moment(dateOfBirth).format("DD/MM/YYYY") : "NULL"}
            </XText>
          </HStack>
        </HStack>
        <HStack HAlign="]">
          <XButton notInjectColor onPress={() => this._toPopupDetails(_id)} padding={0} pV={2}>
            <HStack>
              <XText fontSize={12} color={ColorX.CSS("Axit")} style={{textDecoration: "underline"}}>
                {LocaleX.Parse({
                  EN: "View Details",
                  TC: "顯示詳細資料"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </VStack>
    );
  }

  renderMaidList(){
    let {docs, page, pageSize} = this.state;
    let _docs = _.slice(docs, page * pageSize, (page + 1) * pageSize);
    if(_docs.length === 0){
      return QUICKUI.NoDocs({
        EN: "No Helper Records",
        TC: "沒有助理紀錄。"
      });
    }
    return (
      <VStack fullWidth>
        <HStack flexWrap="wrap" HAlign="[">
          {_.map(_docs, (o, i) => {
            return this.renderMaidDoc(o, i);
          })}
        </HStack>
        <PageFlipper totalDocs={docs.length} 
          page={page}
          pageSize={pageSize}
          pageSizeOptions={[6, 12, 18, 24]}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top" 
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  renderMaids(){
    return (
      <VStack fullWidth mT={20}>
        {this.renderMaidHeader()}
        {this.renderMaidList()}
      </VStack>
    );
  }

  renderSearchText(){
    let {search, searchForm, nationalities} = this.state;
    if(!search) return;
    let {helperName, helperPassport, 
      nationality, dateOfBirth, policyNo} = searchForm;
  
    let searches = [];
    if(helperName) searches.push(helperName);
    if(helperPassport) searches.push(helperPassport);
    if(nationality) {
      let _opt = VarList.GetOption(nationalities, nationality);
      searches.push(LocaleX.Parse(_opt.name));
    }
    if(dateOfBirth) searches.push(ZTime.Moment(dateOfBirth).format("DD/MM/YYYY"));
    if(policyNo) searches.push(policyNo);

    let searchText = searches.join(" - ");

    return (
      <HStack HAlign="[" spacing={5} pV={10}>
        <XText color={ColorX.CSS("Stone")}>
          {LocaleX.Parse({
            EN: "Result for",
            TC: "搜索結果"
          })}
        </XText>
        <XText color={ColorX.CSS("Stone")} bold>
          {`"${searchText}"`}
        </XText>
      </HStack>
    );
  }

  render(){
    return (
      <PAContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth
          p={16}>
          {this.renderHeader()}
          {this.renderSearchForm()}
          {this.renderSearchText()}
          {this.renderMaids()}
        </VStack>
      </PAContainer>
    );
  }

}

export default observer(PAMaidManageW);
